import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseAxios from 'src/utils/baseAxios';

// Async thunks
export const GetCustomerTypeTaxNumberMatching = createAsyncThunk('GetCustomerTypeTaxNumberMatching', async ({ customerTypeId }) => { 
    const params = new URLSearchParams([['customerTypeId', customerTypeId]]);
    const response = await baseAxios.get('/Customer/GetCustomerTypeTaxNumberMatching', { params });
    return response.data;
});

// Slice
const customerSlice = createSlice({
    name: 'customer',
    initialState: {
        taxNumber: ''
    },
    reducers: {
        setCustomerData: (state, action) => {
            state.customerData = action.payload;
        },
    },
    extraReducers: {
        [GetCustomerTypeTaxNumberMatching.pending]: (state) => {
            state.loading = 'Loading';
        },
        [GetCustomerTypeTaxNumberMatching.rejected]: (state, action) => {
            state.error = action.payload;
            state.loading = 'Finished';
        },
        [GetCustomerTypeTaxNumberMatching.fulfilled]: (state, action) => {
            state.taxNumber = action.payload;
            state.loading = 'Finished';
        },
    },
});

export const customerActions = customerSlice.actions;
export const customerThunks = {
    GetCustomerTypeTaxNumberMatching,
};

export default customerSlice.reducer;
